import UploadStatus from './UploadStatus';
import 'react-circular-progressbar/dist/styles.css';
import './UploadStatus.scss';

export default UploadStatus;
